<template>
  <div>
    <div class="sticky z-10 top-0 flex flex-col">
      <div class="flex flex-col rounded-md bg-gray-100 shadow-md p-2">
        <div class="rounded-md bg-gray-50 p-2">
          <div class="text-lg font-bold">Schedules</div>
          <div class="flex flex-row gap-2">
            <Button
              :class="{
                'bg-gray-200': schedule.type === 'future',
              }"
              color="gray"
              size="md"
              @click="setSchedule('future')">
              Future/Upcoming
            </Button>
            <Button
              :class="{
                'bg-gray-200': schedule.type === 'current',
              }"
              color="gray"
              size="md"
              @click="setSchedule('current')">
              Approved/Current
            </Button>
            <Button
              :class="{
                'bg-gray-200': schedule.type === 'request',
              }"
              color="gray"
              size="md"
              @click="setSchedule('request')">
              Requests
            </Button>
          </div>
        </div>
        <div class="flex-row rounded-md bg-gray-50 mt-2"
          v-if="schedule.type !== 'future'">
          <div class="flex-col gap-2">
            <div class="flex flex-row gap-3 p-2"
              v-if="schedule.type !== 'future'">
              <div class="p-2">
                {{ configSelectHelpText }}
              </div>
              <ScheduleTraverseButtons
                @select="(index, dbId) => { setScheduleIndex(schedule, index, dbId) }"
                :schedules="configScheduleSelect"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col rounded-md bg-gray-100 shadow-md p-2 gap-2 mt-4"
      v-if="!expandUtlitiesSection">
      <div class="flex flex-row hover:bg-gray-200"
        @click="toggleUtilitiesSection(true)">
        <div class="font-italic mx-2">Utilities</div>
        <AccordionIcon
          class="flex-shrink"
          :openDirectionDown="true"
          :open="expandUtlitiesSection"
        />
      </div>
      <div class="mx-4 text-sm font-italic">
        {{ utilitiesSectionClosedDisplay }}
      </div>
    </div>
    <div class="flex-row rounded-md bg-gray-100 shadow-md p-2 gap-2 mt-4"
      v-else>
      <div class="flex flex-row hover:bg-gray-200"
        @click="toggleUtilitiesSection(false)">
        <div class="font-italic mx-2">Utilities</div>
        <AccordionIcon
          class="flex-shrink"
          :openDirectionDown="true"
          :open="expandUtlitiesSection"
        />
      </div>
      <div class="flex-row rounded-md bg-gray-50 p-2 gap-2 mt-4">
        <div class="text-sm font-bold">Compare to Schedule:</div>
        <div class="flex flex-row gap-2">
          <Button
            :class="{
              'bg-gray-200': compareSchedule.type === undefined,
            }"
            color="gray"
            size="md"
            @click="setCompareSchedule(undefined)">
            None
          </Button>
          <Button
            :class="{
              'bg-gray-200': compareSchedule.type === 'future',
            }"
            color="gray"
            size="md"
            @click="setCompareSchedule('future')">
            Future/Upcoming
          </Button>
          <Button
            :class="{
              'bg-gray-200': compareSchedule.type === 'current',
            }"
            color="gray"
            size="md"
            @click="setCompareSchedule('current')">
            Approved/Current
          </Button>
          <Button
            :class="{
              'bg-gray-200': compareSchedule.type === 'request',
            }"
            color="gray"
            size="md"
            @click="setCompareSchedule('request')">
            Requests
          </Button>
        </div>
      </div>
      <div class="flex-row rounded-md bg-gray-50 p-2 mt-2"
        v-if="!(compareSchedule.type === 'future' || compareSchedule.type === undefined)">
        <div class="flex-col gap-2">
          <div class="flex flex-row gap-3 p-2"
            v-if="compareSchedule.type !== 'future'">
            <div class="p-2">
              {{ configCompareSelectHelpText }}
            </div>
            <ScheduleTraverseButtons
              @select="(index, dbId) => setScheduleIndex(compareSchedule, index, dbId)"
              :schedules="configCompareScheduleSelect"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="pt-4">
      <Schedule
        :emptySchedule="emptySchedule"
        :scheduleData="scheduleData"
        :scheduleDataDiff="scheduleDataDiff"
      />
    </div>
    <!-- <div class="bg-red-200 p-2">
      <p>{{ scheduleDataDiff }}</p>
    </div> -->
  </div>
</template>

<script>
import { map, isEmpty } from 'lodash'

import Button from '../Button.vue'
import AccordionIcon from '../AccordionIcon.vue'

import Schedule from './Schedule.vue'
import ScheduleTraverseButtons from './utilities/ScheduleTraverseButtons.vue'

import user from '../../services/user/user.js'
import scheduleService from '../../services/studentSchedule/schedule.js'

export default {
  components: {
    Button,
    AccordionIcon,
    Schedule,
    ScheduleTraverseButtons,
  },
  props: {
    studentDbId: Number,
    defaultSelection: Object,
  },
  data() {
    return {
      expandUtlitiesSection: false,
      schedule: {
        dbId: undefined,
        type: 'future',
        index: -1,
      },
      compareSchedule: {
        dbId: undefined,
        type: undefined,
        index: -1,
      },
      emptySchedule: false,

      studentInfoData: undefined,
      scheduleRequestData: undefined,
      futureScheduleData: undefined,

      scheduleData: undefined,
      scheduleDataDiff: undefined,
    }
  },
  methods: {
    setDefaultSelection() {
      if (!this.defaultSelection) return

      if (this.defaultSelection?.schedule?.type) {
        this.schedule.type = this.defaultSelection.schedule.type
      }
      if (this.defaultSelection?.schedule?.index) {
        this.schedule.index = this.defaultSelection.schedule.index
      }

      if (this.defaultSelection?.utilities?.compareSchedule?.type) {
        this.compareSchedule.type = this.defaultSelection.utilities.compareSchedule.type
      }
      if (this.defaultSelection?.utilities?.compareSchedule?.index) {
        this.compareSchedule.index = this.defaultSelection.utilities.compareSchedule.index
      }
    },
    setScheduleBase(scheduleSource, scheduleType) {
      scheduleSource.type = scheduleType
      if (scheduleType === 'current') {
        scheduleSource.index = this.studentInfoData.length - 1
        scheduleSource.dbId = this.studentInfoData[scheduleSource.index]['db_id']
      }
      else if (scheduleType === 'request') {
        scheduleSource.index = this.scheduleRequestData.length - 1
        scheduleSource.dbId = this.scheduleRequestData[scheduleSource.index]['db_id']
      }
      else {
        scheduleSource.index = this.futureScheduleData.length - 1
        scheduleSource.dbId = (!isEmpty(this.futureScheduleData))
          ? this.futureScheduleData[scheduleSource.index]['db_id']
          : undefined
      }
      scheduleSource.idsObject = this.createScheduleIdsObject(scheduleType, scheduleSource.dbId)
    },
    setSchedule(scheduleType) {
      this.setScheduleBase(this.schedule, scheduleType)
    },
    setCompareSchedule(scheduleType) {
      this.setScheduleBase(this.compareSchedule, scheduleType)
    },
    setScheduleIndex(scheduleObj, newIndex, dbId) {
      scheduleObj.index = newIndex
      scheduleObj.dbId = dbId
      scheduleObj.idsObject = this.createScheduleIdsObject(scheduleObj.type, dbId)
    },
    createScheduleIdsObject(scheduleType, dbId) {
      if (dbId === undefined) {
        return undefined
      }
      if (scheduleType === 'current') {
        return { 'studentInfoId': dbId }
      }
      else if (scheduleType === 'request') {
        return { 'scheduleRequestId': dbId }
      }
      else {
        return { 'futureScheduleId': dbId }
      }
    },
    toggleUtilitiesSection(expandSection) {
      this.expandUtlitiesSection = expandSection
    },

    setScheduleSelectData(selectionObj) {
      if (selectionObj.type === 'current') {
        return map(this.studentInfoData, (elem) => {
          return {
            dbId: elem['db_id'],
            startDate: elem['start_date'],
            endDate: elem['end_date'],
          }
        })
      }
      else if (selectionObj.type === 'request') {
        return map(this.scheduleRequestData, (elem) => {
          return {
            dbId: elem['db_id'],
            startDate: elem['requested_start_date'],
            endDate: elem['requested_end_date'],
          }
        })
      }
      else {
        return []
      }
    },

    async loadSchedule() {
      if (this.schedule.dbId === undefined) {
        this.emptySchedule = true
        this.scheduleData = undefined
        return
      }
      this.emptySchedule = false

      this.scheduleData = await scheduleService.getScheduleFromServer(
        this.studentDbId,
        this.schedule.type, this.schedule.idsObject,
      )
      console.log(this.scheduleData)
      if (this.scheduleData === undefined) {
        this.emptySchedule = true
      }
    },
    async loadScheduleDiff() {
      if (this.compareSchedule.type === undefined || this.compareSchedule.dbId === undefined) {
        this.scheduleDataDiff = undefined
        return
      }
      this.scheduleDataDiff = await scheduleService.getScheduleDiffFromServer(
        this.studentDbId,
        this.schedule.type, this.schedule.dbId,
        this.compareSchedule.type, this.compareSchedule.dbId,
      )
    },
  },
  async mounted() {
    await user.ready()
    if (this.studentDbId) {
      let serverData = await scheduleService.getAllStudentSchedulesFromServer(this.studentDbId)
      this.setDefaultSelection()

      this.studentInfoData = serverData.studentInfos
      this.scheduleRequestData = serverData.scheduleRequests
      this.futureScheduleData = serverData.futureSchedules
      this.setSchedule(this.schedule.type)
    }
  },
  computed: {
    utilitiesSectionClosedDisplay() {
      if (this.compareSchedule.type !== undefined) {
        return 'comparing schedules'
      }
      return undefined
    },
    configScheduleSelect() {
      return this.setScheduleSelectData(this.schedule)
    },
    configCompareScheduleSelect() {
      return this.setScheduleSelectData(this.compareSchedule)
    },
    configSelectHelpText() {
      return (this.schedule.type === 'current') ? 'Select Schedule:' : 'Select Request:'
    },
    configCompareSelectHelpText() {
      return (this.compareSchedule.type === 'current') ? 'Select Schedule:' : 'Select Request:'
    },
  },
  watch: {
    defaultSelection() {
      this.setDefaultSelection()
    },
    schedule: {
      deep: true,
      handler() {
        this.loadSchedule()
        this.loadScheduleDiff()
      },
    },
    compareSchedule: {
      deep: true,
      handler() {
        this.loadSchedule()
        this.loadScheduleDiff()
      },
    },
  },
}
</script>
